export default __webpack_public_path__ + "8d85cefc6c6b20d66c3e78dc73b0addb.png";